import { SvgIcon, useMediaQuery, useTheme } from "@mui/material";

const MenuIcon = ({ color }: any) => {

    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <SvgIcon sx={{ fontSize: belowsm ? 32 : 26 }}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_541_145563)">
                    <path d="M28 9H4V11H28V9Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M28 15H4V17H28V15Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M28 21H4V23H28V21Z" fill={color || theme.palette.secondary.contrastText} />
                </g>
                <defs>
                    <clipPath id="clip0_541_145563">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );

};

export default MenuIcon;